import { clone, defaults, flatMap, keys, uniq, zipObject } from 'lodash';

/**
 * Ensures all objects in the array have the same properties.
 * Missing properties are set to `undefined`.
 * @param items - Array of objects with potentially missing properties.
 * @returns A new array where each object has the same properties, with missing ones set to `undefined`.
 */
export function setMissingProperties<T extends Record<string, any>>(items: T[]): T[] {
  const allKeys = uniq(flatMap(items, keys));
  const defaultValues = zipObject(allKeys, Array(allKeys.length).fill(undefined));
  return items.map((item) => {
    return defaults(clone(item), defaultValues);
  });
}
